// removed by extract-text-webpack-plugin
module.exports = {"login-to-see-price":"login-to-see-price___TWjeS","icon-link":"icon-link___3edRS","link":"link___osGH7","icon":"icon___9mquq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemPriceGateway/ItemPriceGatewayContainer.scss
// module id = KlEt
// module chunks = 57